// Public entry point for the ImageOrientationNormalizer module.
//
// Normalizes a gallery-picked image to a fresh JPEG with display-oriented
// pixels and EXIF Orientation=1. Throws on hard failure — callers MUST surface
// the error and cancel; never proceed with the un-normalized input URI.
//
// Only the `photo-asset` source (PhotoKit on iOS when an assetId is provided)
// is stale-EXIF-resistant. The `imageio` and `exifinterface` paths are
// metadata-faithful — they trust the file's EXIF tag and cannot detect a
// lying tag.

import type {
  NormalizePickedImageOptions,
  NormalizedImage,
  NormalizationSource,
} from './ImageOrientationNormalizer.types';
import ImageOrientationNormalizerModule from './ImageOrientationNormalizerModule';

export type { NormalizePickedImageOptions, NormalizedImage, NormalizationSource };

export function normalizePickedImage(
  options: NormalizePickedImageOptions
): Promise<NormalizedImage> {
  return ImageOrientationNormalizerModule.normalizePickedImage(options);
}
